import { sword_slash_2h } from "../../../abilities/sword/sword-actions-2h";
const EXECUTIONERS_BLADE = {
  slug: "executioners-blade",
  name: "Executioner's Blade",
  description: "One swing, one end",
  rarity: "epic",
  slot: "weapon",
  shopCategory: "2h-melee",
  statChanges: [
    {
      stat: "attackDamage",
      value: 40
    },
    {
      stat: "attackspeed",
      value: 5
    }
  ],
  grantedActions: { sword_slash_2h },
  sprite: {
    sheet: "weapons/melee_weapons/sword_big",
    frameIndex: 2
  },
  tags: ["daily-rotation", "two-handed", "2h-melee"]
};
export {
  EXECUTIONERS_BLADE
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vLi4vbGliL2l0ZW1zL3dlYXBvbnMvdHdvLWhhbmRlZC1zd29yZHMvZXhlY3V0aW9uZXJzLWJsYWRlLnRzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyIvKipcbiAqIEV4ZWN1dGlvbmVyJ3MgQmxhZGUgLSBFcGljIHR3by1oYW5kZWQgd2VhcG9uXG4gKi9cblxuaW1wb3J0IHsgSXRlbURlZmluaXRpb24gfSBmcm9tICcuLi8uLi90eXBlcyc7XG5pbXBvcnQgeyBzd29yZF9zbGFzaF8yaCB9IGZyb20gJy4uLy4uLy4uL2FiaWxpdGllcy9zd29yZC9zd29yZC1hY3Rpb25zLTJoJztcblxuZXhwb3J0IGNvbnN0IEVYRUNVVElPTkVSU19CTEFERTogSXRlbURlZmluaXRpb24gPSB7XG4gIHNsdWc6ICdleGVjdXRpb25lcnMtYmxhZGUnLFxuICBuYW1lOiBcIkV4ZWN1dGlvbmVyJ3MgQmxhZGVcIixcbiAgZGVzY3JpcHRpb246ICdPbmUgc3dpbmcsIG9uZSBlbmQnLFxuICByYXJpdHk6ICdlcGljJyxcbiAgc2xvdDogJ3dlYXBvbicsXG5cbiAgc2hvcENhdGVnb3J5OiAnMmgtbWVsZWUnLFxuICBzdGF0Q2hhbmdlczogW1xuICAgIHtcbiAgICAgIHN0YXQ6ICdhdHRhY2tEYW1hZ2UnLFxuICAgICAgdmFsdWU6IDQwLFxuICAgIH0sXG4gICAge1xuICAgICAgc3RhdDogJ2F0dGFja3NwZWVkJyxcbiAgICAgIHZhbHVlOiA1LFxuICAgIH0sXG4gIF0sXG4gIGdyYW50ZWRBY3Rpb25zOiB7IHN3b3JkX3NsYXNoXzJoIH0sXG4gIHNwcml0ZToge1xuICAgIHNoZWV0OiAnd2VhcG9ucy9tZWxlZV93ZWFwb25zL3N3b3JkX2JpZycsXG4gICAgZnJhbWVJbmRleDogMixcbiAgfSxcbiAgdGFnczogWydkYWlseS1yb3RhdGlvbicsICd0d28taGFuZGVkJywgJzJoLW1lbGVlJ10sXG59O1xuIl0sCiAgIm1hcHBpbmdzIjogIkFBS0EsU0FBUyxzQkFBc0I7QUFFeEIsTUFBTSxxQkFBcUM7QUFBQSxFQUNoRCxNQUFNO0FBQUEsRUFDTixNQUFNO0FBQUEsRUFDTixhQUFhO0FBQUEsRUFDYixRQUFRO0FBQUEsRUFDUixNQUFNO0FBQUEsRUFFTixjQUFjO0FBQUEsRUFDZCxhQUFhO0FBQUEsSUFDWDtBQUFBLE1BQ0UsTUFBTTtBQUFBLE1BQ04sT0FBTztBQUFBLElBQ1Q7QUFBQSxJQUNBO0FBQUEsTUFDRSxNQUFNO0FBQUEsTUFDTixPQUFPO0FBQUEsSUFDVDtBQUFBLEVBQ0Y7QUFBQSxFQUNBLGdCQUFnQixFQUFFLGVBQWU7QUFBQSxFQUNqQyxRQUFRO0FBQUEsSUFDTixPQUFPO0FBQUEsSUFDUCxZQUFZO0FBQUEsRUFDZDtBQUFBLEVBQ0EsTUFBTSxDQUFDLGtCQUFrQixjQUFjLFVBQVU7QUFDbkQ7IiwKICAibmFtZXMiOiBbXQp9Cg==
